import React from 'react';
import { useIsFetching } from '@tanstack/react-query';
import LoadingBar from '../components/LoadingBar.tsx';

function LoadingBarContainer() {
  const isFetching = useIsFetching();
  return <LoadingBar active={isFetching > 0} />;
}

export default LoadingBarContainer;
